import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { useAppVersionCheck } from '../hooks/useAppVersionCheck';

const UPDATE_TOAST_ID = 'app-update-available';
const REASSERT_INTERVAL_MS = 30 * 1000;

const handleRefresh = () => {
  window.location.reload();
};

const UpdateToastContent = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
    <span>A new version of ReelTrak is available.</span>
    <Button color="primary" size="small" onClick={handleRefresh}>
      Refresh
    </Button>
  </div>
);

const AppUpdateNotifier = () => {
  const updateAvailable = useAppVersionCheck();

  useEffect(() => {
    if (!updateAvailable) return;

    const showToast = () => {
      if (toast.isActive(UPDATE_TOAST_ID)) return;
      toast.info(<UpdateToastContent />, {
        toastId: UPDATE_TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
      });
    };

    // Other toasts in the app dismiss-all indiscriminately (see
    // Utils/toastify.ts), which can wipe this one out. Re-assert it
    // periodically so a deploy notice can't get silently lost.
    showToast();
    const intervalId = setInterval(showToast, REASSERT_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [updateAvailable]);

  return null;
};

export default AppUpdateNotifier;
